import { render, staticRenderFns } from "./oddSetting.vue?vue&type=template&id=03941e70&scoped=true"
import script from "./oddSetting.vue?vue&type=script&lang=js"
export * from "./oddSetting.vue?vue&type=script&lang=js"
import style0 from "./oddSetting.vue?vue&type=style&index=0&id=03941e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03941e70",
  null
  
)

export default component.exports